const CryptoJS = require("crypto-js"); //引用AES源码js

var IV = "s2*%igla*9)(#kf5";

var KEY = "0@ea4#9$4$b%3^&4&c*f(f)d678&&853";
/**
 * 加密
 */
export function Encrypt(str) {
  var key = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(KEY)); // 秘钥

  var iv = CryptoJS.enc.Utf8.parse(IV); //向量iv
  var encrypted = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
/**
 * 解密
 * @param str
 */
export function Decrypt(str) {
  var key = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(KEY)); // 秘钥
  var iv = CryptoJS.enc.Utf8.parse(IV); //向量iv
  var decrypted = CryptoJS.AES.decrypt(str, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
/**
 * 解密  并将字符串转换成obj对象
 * @param str
 */
export function DecryptObj(str) {
  var key = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(KEY)); // 秘钥
  var iv = CryptoJS.enc.Utf8.parse(IV); //向量iv
  var decrypted = CryptoJS.AES.decrypt(str, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7
  });
  var userArr = decrypted.toString(CryptoJS.enc.Utf8).split("&");
  let obj = {};
  userArr.map(item => {
    let itemArr = item.split("=");
    obj[itemArr[0]] = itemArr[1];
  });
  return obj;
}



// WEBPACK FOOTER //
// ./src/assets/js/encryp.js